// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--a2167";
export var links = "styles-module--links--3e4aa";
export var outer = "styles-module--outer--38cf4";